import {
  addDoc,
  deleteDoc,
  getDocs,
  where,
  query,
  serverTimestamp,
  updateDoc,
  arrayUnion,
  setDoc,
} from "firebase/firestore";
import {
  getInvoiceCollectionRef,
  getRefundsCollectionRef,
} from "../../../firebase/collectionReferences";

// add refund
export async function createRefund(data) {
  try {
    const refundRef = getRefundsCollectionRef();
    const refund = await addDoc(refundRef, {
      ...data,
      createdAt: serverTimestamp(),
    });
    return refund.id;
  } catch (error) {
    console.error("Error creating or updating refund:", error);
  }
}

// Get ALl Invoices
export async function getAllInvoices() {
  let usersRef = getInvoiceCollectionRef();

  return (await getDocs(usersRef)).docs.map((row) => ({
    ...row.data(),
    id: row.id,
  }));
}
